import { DownloadButton } from 'components/DownloadButton';
import { getLineDataCsv } from 'utils/helpers/fileGenerators';

const CSV_FILE_NAME_GENERIC = 'Order_Information.csv';
const CSV_APPLICATION_TYPE = 'application/csv';

const saveByteArray = (fileName, byteArray) => {
  const dataBlob = new Blob([byteArray], { CSV_APPLICATION_TYPE });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(dataBlob);
  link.download = fileName;
  link.click();
};

const getCsvFileName = (orderData) => {
  const poNumber = orderData.billingInfo?.purchaseOrderNumber;
  const soldToCustomer = orderData.billingInfo?.accountName;

  return poNumber && soldToCustomer ? `${soldToCustomer}_${poNumber}.csv` : CSV_FILE_NAME_GENERIC;
};

const downloadCsv = (orderData) => {
  const csvDataStr = getLineDataCsv(orderData);
  const byteArray = new TextEncoder().encode(csvDataStr);
  saveByteArray(getCsvFileName(orderData), byteArray);
};

const FsanDownloadButton = ({ orderData }) => {
  return orderData.lines?.length ? (
    <DownloadButton data={orderData} onClick={downloadCsv} label="Download" />
  ) : null;
};

export { FsanDownloadButton };
